var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotoPeopleHoldingHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 48,
    viewBox: "0 0 91 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.985 19.875C26.985 19.875 25.6613 24.3488 25.11 25.6238L23.4638 29.7563C23.2013 30.3375 23.4338 31.0988 23.985 31.4175C24.6188 31.7813 25.5375 31.5075 25.8413 30.8438L30.5437 20.94L30.165 19.6425L26.985 19.875Z",
    fill: "url(#paint0_linear_3_15421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9965 20.2635C69.9965 20.2635 68.6728 24.7373 68.1215 26.0123L66.4753 30.1448C66.2128 30.726 66.4453 31.4873 66.9965 31.806C67.6303 32.1698 68.549 31.896 68.8528 31.2323L73.5553 21.3285L73.1765 20.031L69.9965 20.2635Z",
    fill: "url(#paint1_linear_3_15421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8888 26.1862L24.2213 27.8587L24.7613 28.8937L26.2275 30.045L27.6038 27.1425L24.8888 26.1862Z",
    fill: "url(#paint2_linear_3_15421)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9003 26.5747L67.2328 28.2472L67.7728 29.2822L69.239 30.4335L70.6153 27.531L67.9003 26.5747Z",
    fill: "url(#paint3_linear_3_15421)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.585 27.9788V46.0088H37.4663L34.515 31.68C34.5 31.59 34.425 31.5263 34.3425 31.5263C34.26 31.5263 34.185 31.59 34.17 31.68L31.2188 46.0088H29.1V27.9788H39.585Z",
    fill: "#7C7C7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5965 28.3672V46.3972H80.4778L77.5265 32.0684C77.5115 31.9784 77.4365 31.9147 77.354 31.9147C77.2715 31.9147 77.1965 31.9784 77.1815 32.0684L74.2303 46.3972H72.1115V28.3672H82.5965Z",
    fill: "#7C7C7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4788 46.5H40.1475C40.455 46.4925 40.6763 46.14 40.5863 45.8325C40.3088 44.895 39.465 44.2125 38.4788 44.2125C37.4738 44.2125 36.6188 44.925 36.3563 45.885C36.2738 46.1925 36.5025 46.4963 36.81 46.4963C36.81 46.5 38.4788 46.5 38.4788 46.5ZM30.21 46.5H28.5413C28.2338 46.4925 28.0125 46.14 28.1025 45.8325C28.38 44.895 29.2238 44.2125 30.21 44.2125C31.215 44.2125 32.07 44.925 32.3325 45.885C32.415 46.1925 32.1863 46.4963 31.8788 46.4963C31.8788 46.5 30.21 46.5 30.21 46.5Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4903 46.8883H83.159C83.4665 46.8808 83.6878 46.5283 83.5978 46.2208C83.3203 45.2833 82.4765 44.6008 81.4903 44.6008C80.4853 44.6008 79.6303 45.3133 79.3678 46.2733C79.2853 46.5808 79.514 46.8846 79.8215 46.8846C79.8215 46.8883 81.4903 46.8883 81.4903 46.8883ZM73.2215 46.8883H71.5528C71.2453 46.8808 71.024 46.5283 71.114 46.2208C71.3915 45.2833 72.2353 44.6008 73.2215 44.6008C74.2265 44.6008 75.0815 45.3133 75.344 46.2733C75.4265 46.5808 75.1978 46.8846 74.8903 46.8846C74.8903 46.8883 73.2215 46.8883 73.2215 46.8883Z",
    fill: "#424242"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5375 20.2875L41.175 20.0625C41.175 20.0625 42.8625 23.8125 43.425 25.0613C43.425 25.0613 45.015 27.4313 45.7388 28.5C46.4438 29.22 46.6238 29.4825 46.8788 30.4463C47.16 31.5075 47.0288 32.0887 46.8938 32.3438C46.7625 32.6025 46.05 33.2662 45.6113 32.8612C45.1463 32.43 45.18 30.9038 44.745 31.0088C44.52 31.065 44.805 31.5188 44.8313 31.9688C44.8575 32.4187 44.5125 32.4975 44.2688 32.3738C44.145 32.31 43.575 31.3575 43.575 31.3575L43.3313 29.7788L37.6575 21.8175L37.5375 20.2875Z",
    fill: "url(#paint4_linear_3_15421)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.549 20.6759L84.1865 20.4509C84.1865 20.4509 85.874 24.2009 86.4365 25.4497C86.4365 25.4497 88.0265 27.8197 88.7503 28.8884C89.4553 29.6084 89.6353 29.8709 89.8903 30.8347C90.1715 31.8959 90.0403 32.4772 89.9053 32.7322C89.774 32.9909 89.0615 33.6547 88.6228 33.2497C88.1578 32.8184 88.1915 31.2922 87.7565 31.3972C87.5315 31.4534 87.8165 31.9072 87.8428 32.3572C87.869 32.8072 87.524 32.8859 87.2803 32.7622C87.1565 32.6984 86.5865 31.7459 86.5865 31.7459L86.3428 30.1672L80.669 22.2059L80.549 20.6759Z",
    fill: "url(#paint5_linear_3_15421)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3525 16.8263C31.26 16.5863 32.8463 16.4288 34.3463 16.4288C35.8463 16.425 37.4175 16.5863 38.325 16.8263C41.1563 17.58 41.8575 18.9113 42.7013 21.195L39.5963 22.395V29.25H29.0963V22.395L25.9575 21.195C26.8013 18.9113 27.5213 17.58 30.3525 16.8263Z",
    fill: "url(#paint6_linear_3_15421)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.364 17.2147C74.2715 16.9747 75.8578 16.8172 77.3578 16.8172C78.8578 16.8135 80.429 16.9747 81.3365 17.2147C84.1678 17.9685 84.869 19.2997 85.7128 21.5835L82.6078 22.7835V29.6385H72.1078V22.7835L68.969 21.5835C69.8128 19.2997 70.5328 17.9685 73.364 17.2147Z",
    fill: "url(#paint7_linear_3_15421)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9825 13.8788C39.78 13.5113 40.0388 13.1363 40.4775 12.6713C41.175 11.9363 41.9363 10.23 41.2313 8.49375C41.235 8.4825 41.0925 8.19 41.0963 8.1825L40.8038 8.1675C40.71 8.1525 37.5188 8.14875 34.3238 8.14875C31.1288 8.14875 27.9375 8.15625 27.8438 8.1675C27.8438 8.1675 27.4125 8.4825 27.4163 8.49375C26.7113 10.2263 27.4688 11.9325 28.17 12.6713C28.6088 13.1363 28.8675 13.5113 28.665 13.8788C28.47 14.235 27.885 14.2875 27.885 14.2875C27.885 14.2875 28.02 14.655 28.3425 14.85C28.6425 15.0338 29.0138 15.075 29.2688 15.0825C29.2688 15.0825 30.2663 16.4625 32.8725 16.4625H35.775C38.3813 16.4625 39.3788 15.0825 39.3788 15.0825C39.6338 15.075 40.0013 15.0338 40.305 14.85C40.6313 14.6513 40.7625 14.2875 40.7625 14.2875C40.7625 14.2875 40.1775 14.235 39.9825 13.8788Z",
    fill: "#543930"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.994 14.2671C82.7915 13.8996 83.0503 13.5246 83.489 13.0596C84.1865 12.3246 84.9478 10.6184 84.2428 8.88211C84.2465 8.87086 84.104 8.57836 84.1078 8.57086L83.8153 8.55586C83.7215 8.54086 80.5303 8.53711 77.3353 8.53711C74.1403 8.53711 70.949 8.54461 70.8553 8.55586C70.8553 8.55586 70.424 8.87086 70.4278 8.88211C69.7228 10.6146 70.4803 12.3209 71.1815 13.0596C71.6203 13.5246 71.879 13.8996 71.6765 14.2671C71.4815 14.6234 70.8965 14.6759 70.8965 14.6759C70.8965 14.6759 71.0315 15.0434 71.354 15.2384C71.654 15.4221 72.0253 15.4634 72.2803 15.4709C72.2803 15.4709 73.2778 16.8509 75.884 16.8509H78.7865C81.3928 16.8509 82.3903 15.4709 82.3903 15.4709C82.6453 15.4634 83.0128 15.4221 83.3165 15.2384C83.6428 15.0396 83.774 14.6759 83.774 14.6759C83.774 14.6759 83.189 14.6234 82.994 14.2671Z",
    fill: "#543930"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3237 16.4625V14.9325L38.955 14.565L39.375 15.0825C39.375 15.0825 38.3775 16.4625 35.7712 16.4625H34.3237Z",
    fill: "url(#paint8_radial_3_15421)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3353 16.8509V15.3209L81.9665 14.9534L82.3865 15.4709C82.3865 15.4709 81.389 16.8509 78.7828 16.8509H77.3353Z",
    fill: "url(#paint9_radial_3_15421)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3675 14.415C38.6738 13.3612 40.2113 12.9675 40.2113 12.9675C39.945 13.3012 39.8213 13.59 39.9788 13.875C40.1738 14.2312 40.7588 14.2837 40.7588 14.2837C40.7588 14.2837 39.9638 14.9962 39.3675 14.415Z",
    fill: "url(#paint10_radial_3_15421)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.379 14.8035C81.6853 13.7497 83.2228 13.356 83.2228 13.356C82.9565 13.6897 82.8328 13.9785 82.9903 14.2635C83.1853 14.6197 83.7703 14.6722 83.7703 14.6722C83.7703 14.6722 82.9753 15.3847 82.379 14.8035Z",
    fill: "url(#paint11_radial_3_15421)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.235 8.49375C41.925 10.1737 41.1975 11.8987 40.5188 12.63C40.425 12.7312 40.0313 13.1175 39.9413 13.4287C39.9413 13.4287 38.3963 11.2725 37.9313 10.005C37.8375 9.75 37.755 9.48375 37.7438 9.21375C37.7363 9.01125 37.7663 8.7675 37.8863 8.595C38.0288 8.38125 41.1563 8.32125 41.1563 8.32125C41.1525 8.3175 41.235 8.49375 41.235 8.49375Z",
    fill: "url(#paint12_radial_3_15421)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2465 8.88228C84.9365 10.5623 84.209 12.2873 83.5303 13.0185C83.4365 13.1198 83.0428 13.506 82.9528 13.8173C82.9528 13.8173 81.4078 11.661 80.9428 10.3935C80.849 10.1385 80.7665 9.87228 80.7553 9.60228C80.7478 9.39978 80.7778 9.15603 80.8978 8.98353C81.0403 8.76978 84.1678 8.70978 84.1678 8.70978C84.164 8.70603 84.2465 8.88228 84.2465 8.88228Z",
    fill: "url(#paint13_radial_3_15421)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.42 8.49375C26.73 10.1738 27.4575 11.8988 28.1362 12.63C28.23 12.7313 28.6237 13.1175 28.7137 13.4288C28.7137 13.4288 30.2587 11.2725 30.7237 10.005C30.8175 9.75 30.9 9.48375 30.9112 9.21375C30.9187 9.01125 30.8887 8.7675 30.7687 8.595C30.6262 8.38125 30.4575 8.4375 30.21 8.4375C29.7412 8.4375 27.7012 8.3175 27.54 8.3175C27.5437 8.3175 27.42 8.49375 27.42 8.49375Z",
    fill: "url(#paint14_radial_3_15421)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4315 8.88206C69.7415 10.5621 70.469 12.2871 71.1477 13.0183C71.2415 13.1196 71.6352 13.5058 71.7252 13.8171C71.7252 13.8171 73.2702 11.6608 73.7352 10.3933C73.829 10.1383 73.9115 9.87206 73.9227 9.60206C73.9302 9.39956 73.9002 9.15581 73.7802 8.98331C73.6377 8.76956 73.469 8.82581 73.2215 8.82581C72.7527 8.82581 70.7127 8.70581 70.5515 8.70581C70.5552 8.70581 70.4315 8.88206 70.4315 8.88206Z",
    fill: "url(#paint15_radial_3_15421)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3312 16.4625V14.9325L29.7 14.565L29.28 15.0825C29.28 15.0825 30.2775 16.4625 32.8837 16.4625H34.3312Z",
    fill: "url(#paint16_radial_3_15421)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3428 16.8509V15.3209L72.7115 14.9534L72.2915 15.4709C72.2915 15.4709 73.289 16.8509 75.8953 16.8509H77.3428Z",
    fill: "url(#paint17_radial_3_15421)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2875 14.415C29.9813 13.3612 28.4438 12.9675 28.4438 12.9675C28.71 13.3012 28.8338 13.59 28.6763 13.875C28.4813 14.2312 27.8963 14.2837 27.8963 14.2837C27.8963 14.2837 28.6875 14.9962 29.2875 14.415Z",
    fill: "url(#paint18_radial_3_15421)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.299 14.8035C72.9928 13.7497 71.4553 13.356 71.4553 13.356C71.7215 13.6897 71.8453 13.9785 71.6878 14.2635C71.4928 14.6197 70.9078 14.6722 70.9078 14.6722C70.9078 14.6722 71.699 15.3847 72.299 14.8035Z",
    fill: "url(#paint19_radial_3_15421)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3275 15.27H32.4525V17.2575C32.4525 18.1575 33.2175 18.885 34.155 18.885H34.5C35.4413 18.885 36.2025 18.1575 36.2025 17.2575V15.27H34.3275ZM38.82 9.1275H29.8388C28.8713 9.1275 28.08 9.97125 28.08 11.0025C28.08 12.0338 28.8713 12.8775 29.8388 12.8775H38.82C39.7875 12.8775 40.5788 12.0338 40.5788 11.0025C40.5788 9.97125 39.7875 9.1275 38.82 9.1275Z",
    fill: "#E59600"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.339 15.6584H75.464V17.6459C75.464 18.5459 76.229 19.2734 77.1665 19.2734H77.5115C78.4528 19.2734 79.214 18.5459 79.214 17.6459V15.6584H77.339ZM81.8315 9.51587H72.8503C71.8828 9.51587 71.0915 10.3596 71.0915 11.3909C71.0915 12.4221 71.8828 13.2659 72.8503 13.2659H81.8315C82.799 13.2659 83.5903 12.4221 83.5903 11.3909C83.5903 10.3596 82.799 9.51587 81.8315 9.51587Z",
    fill: "#E59600"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3275 2.4975C31.47 2.4975 28.8188 5.55375 28.8188 9.95625C28.8188 14.3325 31.5488 16.4963 34.3275 16.4963C37.1063 16.4963 39.8363 14.3325 39.8363 9.95625C39.8325 5.55375 37.185 2.4975 34.3275 2.4975Z",
    fill: "#FFCA28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.339 2.88599C74.4815 2.88599 71.8303 5.94224 71.8303 10.3447C71.8303 14.721 74.5603 16.8847 77.339 16.8847C80.1178 16.8847 82.8478 14.721 82.8478 10.3447C82.844 5.94224 80.1965 2.88599 77.339 2.88599Z",
    fill: "#FFCA28"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8225 5.0025C40.425 4.4025 39.54 3.6 38.745 3.5475C38.6175 2.7825 37.8 2.13375 37.005 1.8825C34.86 1.20375 33.465 1.965 32.715 2.37375C32.5575 2.46 31.5525 3.01875 30.8475 2.6175C30.405 2.36625 30.4125 1.6875 30.4125 1.6875C30.4125 1.6875 29.0288 2.2125 29.5013 3.6825C29.0288 3.70125 28.4025 3.90375 28.0725 4.5675C27.6788 5.3625 27.8175 6.02625 27.9338 6.345C27.525 6.69 27.0113 7.42875 27.3638 8.38875C27.63 9.10875 28.6875 9.4425 28.6875 9.4425C28.6125 10.74 28.8563 11.5388 28.9838 11.865C29.0063 11.9213 29.085 11.9175 29.1 11.8575C29.2613 11.2163 29.8088 8.97375 29.7525 8.58C29.7525 8.58 31.59 8.21625 33.345 6.9225C33.7013 6.66 34.0875 6.435 34.5 6.27C36.705 5.3925 37.1663 6.88875 37.1663 6.88875C37.1663 6.88875 38.6925 6.59625 39.1538 8.715C39.3263 9.51 39.4463 10.7813 39.5438 11.6738C39.5513 11.7375 39.6375 11.7488 39.66 11.6925C39.8138 11.34 40.1213 10.6388 40.1963 9.9225C40.2225 9.67125 40.9013 9.3375 41.19 8.2575C41.5875 6.82125 41.1075 5.4375 40.8225 5.0025Z",
    fill: "#543930"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.834 5.39094C83.4365 4.79094 82.5515 3.98844 81.7565 3.93594C81.629 3.17094 80.8115 2.52219 80.0165 2.27094C77.8715 1.59219 76.4765 2.35344 75.7265 2.76219C75.569 2.84844 74.564 3.40719 73.859 3.00594C73.4165 2.75469 73.424 2.07594 73.424 2.07594C73.424 2.07594 72.0403 2.60094 72.5128 4.07094C72.0403 4.08969 71.414 4.29219 71.084 4.95594C70.6903 5.75094 70.829 6.41469 70.9453 6.73344C70.5365 7.07844 70.0228 7.8172 70.3753 8.7772C70.6415 9.4972 71.699 9.83095 71.699 9.83095C71.624 11.1284 71.8678 11.9272 71.9953 12.2534C72.0178 12.3097 72.0965 12.3059 72.1115 12.2459C72.2728 11.6047 72.8203 9.36219 72.764 8.96844C72.764 8.96844 74.6015 8.60469 76.3565 7.31094C76.7128 7.04844 77.099 6.82344 77.5115 6.65844C79.7165 5.78094 80.1778 7.27719 80.1778 7.27719C80.1778 7.27719 81.704 6.98469 82.1653 9.10345C82.3378 9.89845 82.4578 11.1697 82.5553 12.0622C82.5628 12.1259 82.649 12.1372 82.6715 12.0809C82.8253 11.7284 83.1328 11.0272 83.2078 10.3109C83.234 10.0597 83.9128 9.72595 84.2015 8.64595C84.599 7.20969 84.119 5.82594 83.834 5.39094Z",
    fill: "#543930"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1963 9.93C40.2225 9.67875 40.9013 9.345 41.19 8.265C41.22 8.14875 41.2463 8.0325 41.2725 7.91625C41.5088 6.60375 41.085 5.4 40.8188 5.0025C40.4513 4.4475 39.6675 3.72375 38.9213 3.57375C38.8575 3.56625 38.7938 3.55875 38.7338 3.555C38.7338 3.555 38.7863 3.90375 38.6475 4.18125C38.4638 4.54125 38.0963 4.6275 38.0963 4.6275C40.0388 6.57 39.9 8.19375 40.1963 9.93Z",
    fill: "url(#paint20_radial_3_15421)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2078 10.3184C83.234 10.0671 83.9128 9.73336 84.2015 8.65336C84.2315 8.53711 84.2578 8.42086 84.284 8.30461C84.5203 6.99211 84.0965 5.78836 83.8303 5.39086C83.4628 4.83586 82.679 4.11211 81.9328 3.96211C81.869 3.95461 81.8053 3.94711 81.7453 3.94336C81.7453 3.94336 81.7978 4.29211 81.659 4.56961C81.4753 4.92961 81.1078 5.01586 81.1078 5.01586C83.0503 6.95836 82.9115 8.58211 83.2078 10.3184Z",
    fill: "url(#paint21_radial_3_15421)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1838 2.13C33.0075 2.21625 32.85 2.3025 32.715 2.37375C32.5575 2.46 31.5525 3.01875 30.8475 2.6175C30.4125 2.37375 30.4125 1.71375 30.4125 1.69125C30.2138 1.94625 29.61 3.765 31.3725 3.885C32.1338 3.9375 32.6025 3.27375 32.88 2.71125C32.9813 2.50875 33.1388 2.2125 33.1838 2.13Z",
    fill: "url(#paint22_radial_3_15421)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1953 2.51834C76.019 2.60459 75.8615 2.69084 75.7265 2.76209C75.569 2.84834 74.564 3.40709 73.859 3.00584C73.424 2.76209 73.424 2.10209 73.424 2.07959C73.2253 2.33459 72.6215 4.15334 74.384 4.27334C75.1453 4.32584 75.614 3.66209 75.8915 3.09959C75.9928 2.89709 76.1503 2.60084 76.1953 2.51834Z",
    fill: "url(#paint23_radial_3_15421)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7838 1.81875C37.9725 2.14125 38.55 2.745 38.7413 3.55125C38.7975 3.7875 38.865 5.99625 34.65 3.4875C33.0825 2.55375 33.51 1.96875 33.6938 1.905C34.41 1.6425 35.4525 1.45875 36.7838 1.81875Z",
    fill: "url(#paint24_radial_3_15421)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7953 2.20711C80.984 2.52961 81.5615 3.13336 81.7528 3.93961C81.809 4.17586 81.8765 6.38461 77.6615 3.87586C76.094 2.94211 76.5215 2.35711 76.7053 2.29336C77.4215 2.03086 78.464 1.84711 79.7953 2.20711Z",
    fill: "url(#paint25_radial_3_15421)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4087 1.69125C30.405 1.69125 30.405 1.695 30.3975 1.695C30.2475 1.75875 29.0625 2.30625 29.505 3.6825L30.765 3.885C29.6475 2.7525 30.4125 1.6875 30.4125 1.6875L30.4087 1.69125Z",
    fill: "url(#paint26_radial_3_15421)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4202 2.07968C73.4165 2.07968 73.4165 2.08343 73.409 2.08343C73.259 2.14718 72.074 2.69468 72.5165 4.07093L73.7765 4.27343C72.659 3.14093 73.424 2.07593 73.424 2.07593L73.4202 2.07968Z",
    fill: "url(#paint27_radial_3_15421)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 3.80625L29.505 3.67875C29.475 3.67875 29.37 3.68625 29.3137 3.6975C28.875 3.7575 28.3575 3.98625 28.0762 4.5675C27.7762 5.19375 27.7837 5.73 27.8662 6.09C27.8887 6.21 27.9375 6.345 27.9375 6.345C27.9375 6.345 28.3237 5.9775 29.2425 5.955L30.285 3.80625Z",
    fill: "url(#paint28_radial_3_15421)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2965 4.19464L72.5165 4.06714C72.4865 4.06714 72.3815 4.07464 72.3252 4.08589C71.8865 4.14589 71.369 4.37464 71.0878 4.95589C70.7878 5.58214 70.7952 6.11839 70.8777 6.47839C70.9002 6.59839 70.949 6.73339 70.949 6.73339C70.949 6.73339 71.3353 6.36589 72.254 6.34339L73.2965 4.19464Z",
    fill: "url(#paint29_radial_3_15421)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 6.375C27.5175 6.71625 27 7.4775 27.3788 8.41875C27.6675 9.13125 28.6913 9.43875 28.6913 9.43875C28.6913 9.4425 28.8975 9.5025 29.0025 9.5025L29.2425 5.95125C28.7513 5.95125 28.2788 6.0975 27.975 6.31125C27.9788 6.31875 27.9 6.37125 27.9 6.375Z",
    fill: "url(#paint30_radial_3_15421)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9115 6.76335C70.529 7.1046 70.0115 7.86585 70.3903 8.8071C70.679 9.5196 71.7028 9.8271 71.7028 9.8271C71.7028 9.83085 71.909 9.89085 72.014 9.89085L72.254 6.3396C71.7628 6.3396 71.2903 6.48585 70.9865 6.6996C70.9903 6.7071 70.9115 6.7596 70.9115 6.76335Z",
    fill: "url(#paint31_radial_3_15421)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7113 13.4963C35.1863 13.8075 33.4725 13.8075 32.9475 13.4963C32.6475 13.3163 32.34 13.59 32.4637 13.8638C32.5875 14.1338 33.5213 14.7562 34.3313 14.7562C35.1413 14.7562 36.0637 14.1338 36.1875 13.8638C36.3112 13.59 36.0113 13.3163 35.7113 13.4963Z",
    fill: "#795548"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7228 13.8847C78.1978 14.1959 76.484 14.1959 75.959 13.8847C75.659 13.7047 75.3515 13.9784 75.4753 14.2522C75.599 14.5222 76.5328 15.1447 77.3428 15.1447C78.1528 15.1447 79.0753 14.5222 79.199 14.2522C79.3228 13.9784 79.0228 13.7047 78.7228 13.8847Z",
    fill: "#795548"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9613 12.15C34.9443 12.1433 34.9267 12.1383 34.9088 12.135H33.7463C33.7275 12.1388 33.7088 12.1425 33.6938 12.15C33.5888 12.1913 33.5288 12.3 33.5813 12.42C33.63 12.5363 33.8625 12.8625 34.3275 12.8625C34.7925 12.8625 35.025 12.5363 35.0738 12.42C35.1225 12.3038 35.0663 12.195 34.9613 12.15Z",
    fill: "#E59600"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9728 12.5384C77.9558 12.5317 77.9382 12.5267 77.9203 12.5234H76.7578C76.739 12.5272 76.7203 12.5309 76.7053 12.5384C76.6003 12.5797 76.5403 12.6884 76.5928 12.8084C76.6415 12.9247 76.874 13.2509 77.339 13.2509C77.804 13.2509 78.0365 12.9247 78.0853 12.8084C78.134 12.6922 78.0778 12.5834 77.9728 12.5384Z",
    fill: "#E59600"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6275 11.4638C32.0749 11.4638 32.4375 11.0877 32.4375 10.6238C32.4375 10.1598 32.0749 9.78375 31.6275 9.78375C31.1802 9.78375 30.8175 10.1598 30.8175 10.6238C30.8175 11.0877 31.1802 11.4638 31.6275 11.4638Z",
    fill: "#404040"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0275 11.4638C37.4748 11.4638 37.8375 11.0877 37.8375 10.6238C37.8375 10.1598 37.4748 9.78375 37.0275 9.78375C36.5801 9.78375 36.2175 10.1598 36.2175 10.6238C36.2175 11.0877 36.5801 11.4638 37.0275 11.4638Z",
    fill: "#404040"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M74.639 11.8521C75.0864 11.8521 75.449 11.476 75.449 11.0121C75.449 10.5482 75.0864 10.1721 74.639 10.1721C74.1917 10.1721 73.829 10.5482 73.829 11.0121C73.829 11.476 74.1917 11.8521 74.639 11.8521Z",
    fill: "#404040"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M80.039 11.8521C80.4864 11.8521 80.849 11.476 80.849 11.0121C80.849 10.5482 80.4864 10.1721 80.039 10.1721C79.5917 10.1721 79.229 10.5482 79.229 11.0121C79.229 11.476 79.5917 11.8521 80.039 11.8521Z",
    fill: "#404040"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8275 9.12C35.9813 8.9175 36.3375 8.6175 37.0313 8.6175C37.725 8.6175 38.0813 8.91375 38.235 9.12C38.3025 9.21 38.2875 9.315 38.2388 9.37875C38.1938 9.43875 38.0663 9.49125 37.9238 9.4425C37.7813 9.39375 37.5 9.25125 37.035 9.2475C36.5663 9.25125 36.2888 9.39375 36.1463 9.4425C36.0038 9.49125 35.8725 9.43875 35.8313 9.37875C35.7997 9.34324 35.7819 9.29757 35.7813 9.25007C35.7806 9.20257 35.797 9.15641 35.8275 9.12ZM30.42 9.12C30.5738 8.9175 30.93 8.6175 31.6238 8.6175C32.3175 8.6175 32.6738 8.91375 32.8275 9.12C32.895 9.21 32.88 9.315 32.8313 9.37875C32.7863 9.43875 32.6588 9.49125 32.5163 9.4425C32.3738 9.39375 32.0925 9.25125 31.6275 9.2475C31.1588 9.25125 30.8813 9.39375 30.7388 9.4425C30.5963 9.49125 30.465 9.43875 30.4238 9.37875C30.3939 9.34241 30.3774 9.29703 30.3767 9.25003C30.376 9.20303 30.3913 9.15719 30.42 9.12Z",
    fill: "#6D4C41"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M78.839 9.50836C78.9928 9.30586 79.349 9.00586 80.0428 9.00586C80.7365 9.00586 81.0928 9.30211 81.2465 9.50836C81.314 9.59836 81.299 9.70336 81.2503 9.76711C81.2053 9.82711 81.0778 9.87961 80.9353 9.83086C80.7928 9.78211 80.5115 9.63961 80.0465 9.63586C79.5778 9.63961 79.3003 9.78211 79.1578 9.83086C79.0153 9.87961 78.884 9.82711 78.8428 9.76711C78.8112 9.7316 78.7934 9.68593 78.7928 9.63843C78.7921 9.59093 78.8085 9.54477 78.839 9.50836ZM73.4315 9.50836C73.5853 9.30586 73.9415 9.00586 74.6353 9.00586C75.329 9.00586 75.6853 9.30211 75.839 9.50836C75.9065 9.59836 75.8915 9.70336 75.8428 9.76711C75.7978 9.82711 75.6703 9.87961 75.5278 9.83086C75.3853 9.78211 75.104 9.63961 74.639 9.63586C74.1703 9.63961 73.8928 9.78211 73.7503 9.83086C73.6078 9.87961 73.4765 9.82711 73.4353 9.76711C73.4055 9.73076 73.3889 9.68539 73.3882 9.63839C73.3875 9.59139 73.4028 9.54555 73.4315 9.50836Z",
    fill: "#6D4C41"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44875 27.9788V46.0088H10.5675L13.5188 31.68C13.5338 31.59 13.6088 31.5263 13.6913 31.5263C13.7738 31.5263 13.8488 31.59 13.8638 31.68L16.815 46.0088H18.9338V27.9788H8.44875Z",
    fill: "#7C7C7C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4603 28.3672V46.3972H53.579L56.5303 32.0684C56.5453 31.9784 56.6203 31.9147 56.7028 31.9147C56.7853 31.9147 56.8603 31.9784 56.8753 32.0684L59.8265 46.3972H61.9453V28.3672H51.4603Z",
    fill: "#7C7C7C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.555 46.5H7.88625C7.57875 46.4925 7.3575 46.14 7.4475 45.8325C7.725 44.895 8.56875 44.2125 9.555 44.2125C10.56 44.2125 11.415 44.925 11.6775 45.885C11.76 46.1925 11.5313 46.4963 11.2238 46.4963C11.2238 46.5 9.555 46.5 9.555 46.5ZM17.8238 46.5H19.4925C19.8 46.4925 20.0213 46.14 19.9313 45.8325C19.6538 44.895 18.81 44.2125 17.8238 44.2125C16.8188 44.2125 15.9638 44.925 15.7013 45.885C15.6188 46.1925 15.8475 46.4963 16.155 46.4963C16.155 46.5 17.8238 46.5 17.8238 46.5Z",
    fill: "#424242"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5665 46.8883H50.8978C50.5903 46.8808 50.369 46.5283 50.459 46.2208C50.7365 45.2833 51.5803 44.6008 52.5665 44.6008C53.5715 44.6008 54.4265 45.3133 54.689 46.2733C54.7715 46.5808 54.5428 46.8846 54.2353 46.8846C54.2353 46.8883 52.5665 46.8883 52.5665 46.8883ZM60.8353 46.8883H62.504C62.8115 46.8808 63.0328 46.5283 62.9428 46.2208C62.6653 45.2833 61.8215 44.6008 60.8353 44.6008C59.8303 44.6008 58.9753 45.3133 58.7128 46.2733C58.6303 46.5808 58.859 46.8846 59.1665 46.8846C59.1665 46.8883 60.8353 46.8883 60.8353 46.8883Z",
    fill: "#424242"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4962 20.2875L6.85875 20.0625C6.85875 20.0625 5.17125 23.8125 4.60875 25.0613C4.60875 25.0613 3.01875 27.4313 2.295 28.5C1.59 29.22 1.41 29.4825 1.155 30.4463C0.873748 31.5075 1.005 32.0887 1.14 32.3438C1.275 32.5988 1.98375 33.2662 2.4225 32.8612C2.8875 32.43 2.85375 30.9038 3.28875 31.0088C3.51375 31.065 3.22875 31.5188 3.2025 31.9688C3.17625 32.4187 3.52125 32.4975 3.765 32.3738C3.88875 32.31 4.45875 31.3575 4.45875 31.3575L4.7025 29.7788L10.3762 21.8137L10.4962 20.2875Z",
    fill: "url(#paint32_linear_3_15421)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5078 20.6759L49.8703 20.4509C49.8703 20.4509 48.1828 24.2009 47.6203 25.4497C47.6203 25.4497 46.0303 27.8197 45.3065 28.8884C44.6015 29.6084 44.4215 29.8709 44.1665 30.8347C43.8853 31.8959 44.0165 32.4772 44.1515 32.7322C44.2865 32.9872 44.9953 33.6547 45.434 33.2497C45.899 32.8184 45.8653 31.2922 46.3003 31.3972C46.5253 31.4534 46.2403 31.9072 46.214 32.3572C46.1878 32.8072 46.5328 32.8859 46.7765 32.7622C46.9003 32.6984 47.4703 31.7459 47.4703 31.7459L47.714 30.1672L53.3878 22.2022L53.5078 20.6759Z",
    fill: "url(#paint33_linear_3_15421)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5988 21.555L22.905 30.3713C22.905 30.3713 22.3313 31.3538 22.7588 32.2125C23.3588 32.6438 23.6288 31.3613 23.8613 31.3275C24.3075 31.26 25.0163 33.0375 25.4888 33.0375C26.3925 33.4275 26.8125 32.22 26.8275 31.5075C27.1688 30.2663 24.8138 28.9613 24.8138 28.9613C24.1838 27.8363 23.0625 25.2863 23.0625 25.2863C22.6088 23.9925 21.255 20.1113 21.255 20.1113L17.6138 20.0175L17.5988 21.555Z",
    fill: "url(#paint34_linear_3_15421)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6103 21.9435L65.9165 30.7598C65.9165 30.7598 65.3428 31.7423 65.7703 32.601C66.3703 33.0323 66.6403 31.7498 66.8728 31.716C67.319 31.6485 68.0278 33.426 68.5003 33.426C69.404 33.816 69.824 32.6085 69.839 31.896C70.1803 30.6548 67.8253 29.3498 67.8253 29.3498C67.1953 28.2248 66.074 25.6748 66.074 25.6748C65.6203 24.381 64.2665 20.4998 64.2665 20.4998L60.6253 20.406L60.6103 21.9435Z",
    fill: "url(#paint35_linear_3_15421)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.655 16.8263C16.7475 16.5863 15.1613 16.4288 13.6613 16.4288C12.1613 16.425 10.59 16.5863 9.6825 16.8263C6.85125 17.58 6.15 18.9113 5.30625 21.195L8.41125 22.395V29.25H18.9113V22.395L22.05 21.195C21.2025 18.9113 20.4825 17.58 17.655 16.8263Z",
    fill: "url(#paint36_linear_3_15421)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6665 17.2147C59.759 16.9747 58.1728 16.8172 56.6728 16.8172C55.1728 16.8135 53.6015 16.9747 52.694 17.2147C49.8628 17.9685 49.1615 19.2997 48.3178 21.5835L51.4228 22.7835V29.6385H61.9228V22.7835L65.0615 21.5835C64.214 19.2997 63.494 17.9685 60.6665 17.2147Z",
    fill: "url(#paint37_linear_3_15421)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3312 13.8788C19.1287 13.5113 19.3875 13.1363 19.8262 12.6713C20.5237 11.9363 21.285 10.23 20.58 8.49375C20.5837 8.4825 20.4412 8.19 20.445 8.1825L20.1525 8.1675C20.0587 8.1525 16.8675 8.14875 13.6725 8.14875C10.4775 8.14875 7.28625 8.15625 7.1925 8.1675C7.1925 8.1675 6.76125 8.4825 6.765 8.49375C6.06 10.2263 6.82125 11.9325 7.51875 12.6713C7.9575 13.1363 8.21625 13.5113 8.01375 13.8788C7.81875 14.235 7.23375 14.2875 7.23375 14.2875C7.23375 14.2875 7.36875 14.655 7.695 14.85C7.995 15.0338 8.3625 15.075 8.62125 15.0825C8.62125 15.0825 9.61875 16.4625 12.225 16.4625H15.1275C17.7337 16.4625 18.7312 15.0825 18.7312 15.0825C18.9862 15.075 19.3537 15.0338 19.6575 14.85C19.9837 14.6513 20.115 14.2875 20.115 14.2875C20.115 14.2875 19.5262 14.235 19.3312 13.8788Z",
    fill: "#543930"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3428 14.2671C62.1403 13.8996 62.399 13.5246 62.8378 13.0596C63.5353 12.3246 64.2965 10.6184 63.5915 8.88211C63.5953 8.87086 63.4528 8.57836 63.4565 8.57086L63.164 8.55586C63.0703 8.54086 59.879 8.53711 56.684 8.53711C53.489 8.53711 50.2978 8.54461 50.204 8.55586C50.204 8.55586 49.7728 8.87086 49.7765 8.88211C49.0715 10.6146 49.8328 12.3209 50.5303 13.0596C50.969 13.5246 51.2278 13.8996 51.0253 14.2671C50.8303 14.6234 50.2453 14.6759 50.2453 14.6759C50.2453 14.6759 50.3803 15.0434 50.7065 15.2384C51.0065 15.4221 51.374 15.4634 51.6328 15.4709C51.6328 15.4709 52.6303 16.8509 55.2365 16.8509H58.139C60.7453 16.8509 61.7428 15.4709 61.7428 15.4709C61.9978 15.4634 62.3653 15.4221 62.669 15.2384C62.9953 15.0396 63.1265 14.6759 63.1265 14.6759C63.1265 14.6759 62.5378 14.6234 62.3428 14.2671Z",
    fill: "#543930"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6687 16.4625V14.9325L18.3 14.565L18.72 15.0825C18.72 15.0825 17.7225 16.4625 15.1162 16.4625H13.6687Z",
    fill: "url(#paint38_radial_3_15421)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6803 16.8509V15.3209L61.3115 14.9534L61.7315 15.4709C61.7315 15.4709 60.734 16.8509 58.1278 16.8509H56.6803Z",
    fill: "url(#paint39_radial_3_15421)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7125 14.415C18.0188 13.3612 19.5563 12.9675 19.5563 12.9675C19.29 13.3012 19.1663 13.59 19.3238 13.875C19.5188 14.2312 20.1038 14.2837 20.1038 14.2837C20.1038 14.2837 19.3125 14.9962 18.7125 14.415Z",
    fill: "url(#paint40_radial_3_15421)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M61.724 14.8035C61.0303 13.7497 62.5678 13.356 62.5678 13.356C62.3015 13.6897 62.1778 13.9785 62.3353 14.2635C62.5303 14.6197 63.1153 14.6722 63.1153 14.6722C63.1153 14.6722 62.324 15.3847 61.724 14.8035Z",
    fill: "url(#paint41_radial_3_15421)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 8.49375C21.27 10.1737 20.5425 11.8987 19.8638 12.63C19.77 12.7312 19.3763 13.1175 19.2863 13.4287C19.2863 13.4287 17.7413 11.2725 17.2763 10.005C17.1825 9.75 17.1 9.48375 17.085 9.21375C17.0775 9.01125 17.1075 8.7675 17.2275 8.595C17.37 8.38125 20.4975 8.32125 20.4975 8.32125C20.4975 8.3175 20.58 8.49375 20.58 8.49375Z",
    fill: "url(#paint42_radial_3_15421)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5915 8.88228C64.2815 10.5623 63.554 12.2873 62.8753 13.0185C62.7815 13.1198 62.3878 13.506 62.2978 13.8173C62.2978 13.8173 60.7528 11.661 60.2878 10.3935C60.194 10.1385 60.1115 9.87228 60.0965 9.60228C60.089 9.39978 60.119 9.15603 60.239 8.98353C60.3815 8.76978 63.509 8.70978 63.509 8.70978C63.509 8.70603 63.5915 8.88228 63.5915 8.88228Z",
    fill: "url(#paint43_radial_3_15421)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6.765 8.49375C6.075 10.1738 6.8025 11.8988 7.48125 12.63C7.575 12.7313 7.96875 13.1175 8.05875 13.4288C8.05875 13.4288 9.60375 11.2725 10.0688 10.005C10.1625 9.75 10.2488 9.48375 10.2563 9.21375C10.2638 9.01125 10.2338 8.7675 10.1138 8.595C9.97125 8.38125 9.8025 8.4375 9.555 8.4375C9.08625 8.4375 7.04625 8.3175 6.885 8.3175C6.8925 8.3175 6.765 8.49375 6.765 8.49375Z",
    fill: "url(#paint44_radial_3_15421)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7765 8.88206C49.0865 10.5621 49.814 12.2871 50.4928 13.0183C50.5865 13.1196 50.9803 13.5058 51.0703 13.8171C51.0703 13.8171 52.6153 11.6608 53.0803 10.3933C53.174 10.1383 53.2603 9.87206 53.2678 9.60206C53.2753 9.39956 53.2453 9.15581 53.1253 8.98331C52.9828 8.76956 52.814 8.82581 52.5665 8.82581C52.0978 8.82581 50.0578 8.70581 49.8965 8.70581C49.904 8.70581 49.7765 8.88206 49.7765 8.88206Z",
    fill: "url(#paint45_radial_3_15421)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6763 16.4625V14.9325L9.045 14.565L8.625 15.0825C8.625 15.0825 9.6225 16.4625 12.2288 16.4625H13.6763Z",
    fill: "url(#paint46_radial_3_15421)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6878 16.8509V15.3209L52.0565 14.9534L51.6365 15.4709C51.6365 15.4709 52.634 16.8509 55.2403 16.8509H56.6878Z",
    fill: "url(#paint47_radial_3_15421)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6325 14.415C9.32625 13.3612 7.78875 12.9675 7.78875 12.9675C8.055 13.3012 8.17875 13.59 8.02125 13.875C7.82625 14.2312 7.24125 14.2837 7.24125 14.2837C7.24125 14.2837 8.03625 14.9962 8.6325 14.415Z",
    fill: "url(#paint48_radial_3_15421)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M51.644 14.8035C52.3378 13.7497 50.8003 13.356 50.8003 13.356C51.0665 13.6897 51.1903 13.9785 51.0328 14.2635C50.8378 14.6197 50.2528 14.6722 50.2528 14.6722C50.2528 14.6722 51.0478 15.3847 51.644 14.8035Z",
    fill: "url(#paint49_radial_3_15421)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6763 15.27H15.5513V17.2575C15.5513 18.1575 14.79 18.885 13.845 18.885H13.5038C12.5625 18.885 11.7975 18.1575 11.7975 17.2575V15.27H13.6763ZM18.165 9.1275H9.18375C8.21625 9.1275 7.425 9.97125 7.425 11.0025C7.425 12.0338 8.21625 12.8775 9.18375 12.8775H18.165C19.1325 12.8775 19.9238 12.0338 19.9238 11.0025C19.9238 9.97125 19.1325 9.1275 18.165 9.1275Z",
    fill: "#E59600"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6878 15.6584H58.5628V17.6459C58.5628 18.5459 57.8015 19.2734 56.8565 19.2734H56.5153C55.574 19.2734 54.809 18.5459 54.809 17.6459V15.6584H56.6878ZM61.1765 9.51587H52.1953C51.2278 9.51587 50.4365 10.3596 50.4365 11.3909C50.4365 12.4221 51.2278 13.2659 52.1953 13.2659H61.1765C62.144 13.2659 62.9353 12.4221 62.9353 11.3909C62.9353 10.3596 62.144 9.51587 61.1765 9.51587Z",
    fill: "#E59600"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6725 2.4975C10.815 2.4975 8.16375 5.55375 8.16375 9.95625C8.16375 14.3325 10.8937 16.4963 13.6725 16.4963C16.4512 16.4963 19.1812 14.3325 19.1812 9.95625C19.1812 5.55375 16.53 2.4975 13.6725 2.4975Z",
    fill: "#FFCA28"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56.684 2.88599C53.8265 2.88599 51.1753 5.94224 51.1753 10.3447C51.1753 14.721 53.9053 16.8847 56.684 16.8847C59.4628 16.8847 62.1928 14.721 62.1928 10.3447C62.1928 5.94224 59.5415 2.88599 56.684 2.88599Z",
    fill: "#FFCA28"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0563 13.4963C14.5313 13.8075 12.8175 13.8075 12.2925 13.4963C11.9925 13.3163 11.685 13.59 11.8088 13.8638C11.9325 14.1338 12.8663 14.7562 13.6763 14.7562C14.4863 14.7562 15.4088 14.1338 15.5325 13.8638C15.66 13.59 15.3563 13.3163 15.0563 13.4963Z",
    fill: "#795548"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0678 13.8847C57.5428 14.1959 55.829 14.1959 55.304 13.8847C55.004 13.7047 54.6965 13.9784 54.8203 14.2522C54.944 14.5222 55.8778 15.1447 56.6878 15.1447C57.4978 15.1447 58.4203 14.5222 58.544 14.2522C58.6715 13.9784 58.3678 13.7047 58.0678 13.8847Z",
    fill: "#795548"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1675 5.0025C19.77 4.4025 18.885 3.6 18.09 3.5475C17.9625 2.7825 17.145 2.1375 16.35 1.88625C14.205 1.2075 12.81 1.96875 12.06 2.3775C11.9025 2.46375 10.8975 3.0225 10.1925 2.62125C9.75 2.37 9.7575 1.69125 9.7575 1.69125C9.7575 1.69125 8.37375 2.21625 8.85 3.68625C8.3775 3.705 7.75125 3.9075 7.42125 4.57125C7.0275 5.36625 7.17 6.03 7.2825 6.34875C6.87375 6.69375 6.36 7.4325 6.7125 8.3925C6.97875 9.1125 8.03625 9.44625 8.03625 9.44625C7.96125 10.7438 8.205 11.5425 8.3325 11.8688C8.355 11.925 8.43375 11.9213 8.44875 11.8613C8.61 11.22 9.1575 8.9775 9.10125 8.58375C9.10125 8.58375 10.9425 8.22 12.6937 6.92625C13.05 6.66375 13.4362 6.43875 13.8487 6.27375C16.0537 5.39625 16.5112 6.8925 16.5112 6.8925C16.5112 6.8925 18.0375 6.6 18.4987 8.71875C18.6712 9.51375 18.7912 10.785 18.8887 11.6775C18.8962 11.7413 18.9825 11.7525 19.005 11.6963C19.1587 11.3438 19.4662 10.6425 19.5412 9.92625C19.5675 9.675 20.2462 9.34125 20.535 8.26125C20.9325 6.82125 20.4562 5.4375 20.1675 5.0025Z",
    fill: "#543930"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M63.179 5.39086C62.7815 4.79086 61.8965 3.98836 61.1015 3.93586C60.974 3.17086 60.1565 2.52586 59.3615 2.27461C57.2165 1.59586 55.8215 2.35711 55.0715 2.76586C54.914 2.85211 53.909 3.41086 53.204 3.00961C52.7615 2.75836 52.769 2.07961 52.769 2.07961C52.769 2.07961 51.3853 2.60461 51.8615 4.07461C51.389 4.09336 50.7628 4.29586 50.4328 4.95961C50.039 5.75461 50.1815 6.41836 50.294 6.73711C49.8853 7.08211 49.3715 7.82086 49.724 8.78086C49.9903 9.50086 51.0478 9.83461 51.0478 9.83461C50.9728 11.1321 51.2165 11.9309 51.344 12.2571C51.3665 12.3134 51.4453 12.3096 51.4603 12.2496C51.6215 11.6084 52.169 9.36586 52.1128 8.97211C52.1128 8.97211 53.954 8.60836 55.7053 7.31461C56.0615 7.05211 56.4478 6.82711 56.8603 6.66211C59.0653 5.78461 59.5228 7.28086 59.5228 7.28086C59.5228 7.28086 61.049 6.98836 61.5103 9.10711C61.6828 9.90211 61.8028 11.1734 61.9003 12.0659C61.9078 12.1296 61.994 12.1409 62.0165 12.0846C62.1703 11.7321 62.4778 11.0309 62.5528 10.3146C62.579 10.0634 63.2578 9.72961 63.5465 8.64961C63.944 7.20961 63.4678 5.82586 63.179 5.39086Z",
    fill: "#543930"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.545 9.93C19.5712 9.67875 20.25 9.345 20.5387 8.265C20.5687 8.14875 20.595 8.0325 20.6213 7.91625C20.8575 6.60375 20.4337 5.4 20.1675 5.0025C19.8 4.4475 19.0163 3.72375 18.27 3.57375C18.2062 3.56625 18.1425 3.55875 18.0825 3.555C18.0825 3.555 18.135 3.90375 17.9963 4.18125C17.8125 4.54125 17.445 4.6275 17.445 4.6275C19.3837 6.57 19.245 8.19375 19.545 9.93Z",
    fill: "url(#paint50_radial_3_15421)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5565 10.3184C62.5828 10.0671 63.2615 9.73336 63.5503 8.65336C63.5803 8.53711 63.6065 8.42086 63.6328 8.30461C63.869 6.99211 63.4453 5.78836 63.179 5.39086C62.8115 4.83586 62.0278 4.11211 61.2815 3.96211C61.2178 3.95461 61.154 3.94711 61.094 3.94336C61.094 3.94336 61.1465 4.29211 61.0078 4.56961C60.824 4.92961 60.4565 5.01586 60.4565 5.01586C62.3953 6.95836 62.2565 8.58211 62.5565 10.3184Z",
    fill: "url(#paint51_radial_3_15421)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5287 2.13C12.3525 2.21625 12.195 2.3025 12.06 2.37375C11.9025 2.46 10.8975 3.01875 10.1925 2.6175C9.7575 2.37 9.7575 1.71375 9.7575 1.69125C9.55875 1.94625 8.955 3.765 10.7175 3.885C11.4787 3.9375 11.9475 3.27375 12.225 2.71125C12.33 2.50875 12.4875 2.2125 12.5287 2.13Z",
    fill: "url(#paint52_radial_3_15421)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5403 2.51834C55.364 2.60459 55.2065 2.69084 55.0715 2.76209C54.914 2.84834 53.909 3.40709 53.204 3.00584C52.769 2.75834 52.769 2.10209 52.769 2.07959C52.5703 2.33459 51.9665 4.15334 53.729 4.27334C54.4903 4.32584 54.959 3.66209 55.2365 3.09959C55.3415 2.89709 55.499 2.60084 55.5403 2.51834Z",
    fill: "url(#paint53_radial_3_15421)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1288 1.81875C17.3175 2.14125 17.895 2.745 18.0863 3.55125C18.1425 3.7875 18.21 5.99625 13.995 3.4875C12.4275 2.55375 12.855 1.96875 13.0388 1.905C13.7588 1.6425 14.8013 1.45875 16.1288 1.81875Z",
    fill: "url(#paint54_radial_3_15421)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1403 2.20711C60.329 2.52961 60.9065 3.13336 61.0978 3.93961C61.154 4.17586 61.2215 6.38461 57.0065 3.87586C55.439 2.94211 55.8665 2.35711 56.0503 2.29336C56.7703 2.03086 57.8128 1.84711 59.1403 2.20711Z",
    fill: "url(#paint55_radial_3_15421)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75375 1.69125C9.75 1.69125 9.75 1.695 9.7425 1.695C9.5925 1.75875 8.4075 2.30625 8.85 3.6825L10.11 3.885C8.9925 2.7525 9.7575 1.6875 9.7575 1.6875C9.7575 1.6875 9.7575 1.69125 9.75375 1.69125Z",
    fill: "url(#paint56_radial_3_15421)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7653 2.07968C52.7615 2.07968 52.7615 2.08343 52.754 2.08343C52.604 2.14718 51.419 2.69468 51.8615 4.07093L53.1215 4.27343C52.004 3.14093 52.769 2.07593 52.769 2.07593C52.769 2.07593 52.769 2.07968 52.7653 2.07968Z",
    fill: "url(#paint57_radial_3_15421)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 3.80625L8.85 3.6825C8.82 3.6825 8.715 3.69 8.65875 3.70125C8.22 3.76125 7.7025 3.99 7.42125 4.57125C7.12125 5.1975 7.12875 5.73375 7.21125 6.09375C7.23375 6.21375 7.2825 6.34875 7.2825 6.34875C7.2825 6.34875 7.66875 5.98125 8.5875 5.95875L9.63 3.80625Z",
    fill: "url(#paint58_radial_3_15421)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6415 4.19479L51.8615 4.07104C51.8315 4.07104 51.7265 4.07854 51.6703 4.08979C51.2315 4.14979 50.714 4.37854 50.4328 4.95979C50.1328 5.58604 50.1403 6.1223 50.2228 6.4823C50.2453 6.60229 50.294 6.7373 50.294 6.7373C50.294 6.7373 50.6803 6.3698 51.599 6.3473L52.6415 4.19479Z",
    fill: "url(#paint59_radial_3_15421)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24875 6.375C6.86625 6.71625 6.34875 7.4775 6.7275 8.41875C7.01625 9.13125 8.04 9.43875 8.04 9.43875C8.04 9.4425 8.24625 9.5025 8.35125 9.5025L8.59125 5.95125C8.1 5.95125 7.6275 6.0975 7.32375 6.31125C7.32375 6.31875 7.245 6.37125 7.24875 6.375Z",
    fill: "url(#paint60_radial_3_15421)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2603 6.76335C49.8778 7.1046 49.3603 7.86585 49.739 8.8071C50.0278 9.5196 51.0515 9.8271 51.0515 9.8271C51.0515 9.83085 51.2578 9.89085 51.3628 9.89085L51.6028 6.3396C51.1115 6.3396 50.639 6.48585 50.3353 6.6996C50.3353 6.7071 50.2565 6.7596 50.2603 6.76335Z",
    fill: "url(#paint61_radial_3_15421)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3063 12.15C14.2893 12.1433 14.2717 12.1383 14.2538 12.135H13.0913C13.0725 12.1388 13.0538 12.1425 13.0388 12.15C12.9338 12.1913 12.8738 12.3 12.9263 12.42C12.9788 12.54 13.2075 12.8625 13.6725 12.8625C14.1375 12.8625 14.37 12.5363 14.4188 12.42C14.4675 12.3038 14.4113 12.195 14.3063 12.15Z",
    fill: "#E59600"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3178 12.5384C57.3008 12.5317 57.2832 12.5267 57.2653 12.5234H56.1028C56.084 12.5272 56.0653 12.5309 56.0503 12.5384C55.9453 12.5797 55.8853 12.6884 55.9378 12.8084C55.9903 12.9284 56.219 13.2509 56.684 13.2509C57.149 13.2509 57.3815 12.9247 57.4303 12.8084C57.479 12.6922 57.4228 12.5834 57.3178 12.5384Z",
    fill: "#E59600"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9725 11.4638C11.4198 11.4638 11.7825 11.0877 11.7825 10.6238C11.7825 10.1598 11.4198 9.78375 10.9725 9.78375C10.5251 9.78375 10.1625 10.1598 10.1625 10.6238C10.1625 11.0877 10.5251 11.4638 10.9725 11.4638Z",
    fill: "#404040"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3725 11.4638C16.8199 11.4638 17.1825 11.0877 17.1825 10.6238C17.1825 10.1598 16.8199 9.78375 16.3725 9.78375C15.9251 9.78375 15.5625 10.1598 15.5625 10.6238C15.5625 11.0877 15.9251 11.4638 16.3725 11.4638Z",
    fill: "#404040"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M53.984 11.8521C54.4314 11.8521 54.794 11.476 54.794 11.0121C54.794 10.5482 54.4314 10.1721 53.984 10.1721C53.5367 10.1721 53.174 10.5482 53.174 11.0121C53.174 11.476 53.5367 11.8521 53.984 11.8521Z",
    fill: "#404040"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59.384 11.8521C59.8314 11.8521 60.194 11.476 60.194 11.0121C60.194 10.5482 59.8314 10.1721 59.384 10.1721C58.9367 10.1721 58.574 10.5482 58.574 11.0121C58.574 11.476 58.9367 11.8521 59.384 11.8521Z",
    fill: "#404040"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1725 9.12C15.3263 8.9175 15.6825 8.6175 16.3763 8.6175C17.07 8.6175 17.4263 8.91375 17.58 9.12C17.6475 9.21 17.6325 9.315 17.5838 9.37875C17.5388 9.43875 17.4113 9.49125 17.2688 9.4425C17.1263 9.39375 16.845 9.25125 16.38 9.2475C15.9113 9.25125 15.6338 9.39375 15.4913 9.4425C15.3488 9.49125 15.2175 9.43875 15.1763 9.37875C15.1455 9.34284 15.1283 9.29731 15.1277 9.25005C15.127 9.2028 15.1428 9.15679 15.1725 9.12ZM9.76875 9.12C9.9225 8.9175 10.2788 8.6175 10.9725 8.6175C11.6625 8.6175 12.0225 8.91375 12.1763 9.12C12.2438 9.21 12.2288 9.315 12.18 9.37875C12.135 9.43875 12.0075 9.49125 11.865 9.4425C11.7225 9.39375 11.4413 9.25125 10.9763 9.2475C10.5075 9.25125 10.23 9.39375 10.0875 9.4425C9.945 9.49125 9.81375 9.43875 9.7725 9.37875C9.74094 9.34324 9.7232 9.29757 9.72251 9.25007C9.72182 9.20257 9.73823 9.15641 9.76875 9.12Z",
    fill: "#6D4C41"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.184 9.50836C58.3378 9.30586 58.694 9.00586 59.3878 9.00586C60.0815 9.00586 60.4378 9.30211 60.5915 9.50836C60.659 9.59836 60.644 9.70336 60.5953 9.76711C60.5503 9.82711 60.4228 9.87961 60.2803 9.83086C60.1378 9.78211 59.8565 9.63961 59.3915 9.63586C58.9228 9.63961 58.6453 9.78211 58.5028 9.83086C58.3603 9.87961 58.229 9.82711 58.1878 9.76711C58.1571 9.7312 58.1399 9.68567 58.1392 9.63841C58.1385 9.59116 58.1544 9.54515 58.184 9.50836ZM52.7803 9.50836C52.934 9.30586 53.2903 9.00586 53.984 9.00586C54.674 9.00586 55.034 9.30211 55.1878 9.50836C55.2553 9.59836 55.2403 9.70336 55.1915 9.76711C55.1465 9.82711 55.019 9.87961 54.8765 9.83086C54.734 9.78211 54.4528 9.63961 53.9878 9.63586C53.519 9.63961 53.2415 9.78211 53.099 9.83086C52.9565 9.87961 52.8253 9.82711 52.784 9.76711C52.7525 9.7316 52.7347 9.68593 52.734 9.63843C52.7333 9.59093 52.7498 9.54477 52.7803 9.50836Z",
    fill: "#6D4C41"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2525 32.4C25.1925 32.3738 25.1325 32.3588 25.065 32.3588C25.05 32.3588 25.0388 32.3625 25.0238 32.3663L25.0425 32.3288C25.1475 32.0963 25.0575 31.8188 24.8363 31.7063C24.7763 31.6763 24.7125 31.6613 24.645 31.6613C24.6188 31.6613 24.5925 31.6688 24.5663 31.6725C24.66 31.4475 24.5775 31.1813 24.3675 31.0688C24.3038 31.035 24.2363 31.0163 24.165 31.0163C24.0675 31.0163 23.9738 31.0538 23.8988 31.1138C23.8725 30.975 23.79 30.8438 23.6513 30.7725C23.5875 30.7388 23.52 30.7238 23.4525 30.7238C23.28 30.7238 23.1263 30.825 23.0513 30.9862L22.7063 31.7212C22.5975 31.9537 22.6875 32.2425 22.9238 32.3625C22.9875 32.3963 23.055 32.4113 23.1263 32.4113C23.1975 32.4113 23.2613 32.3888 23.3213 32.3588C23.325 32.3963 23.3213 32.4338 23.3325 32.4675C23.37 32.5875 23.445 32.685 23.55 32.7413C23.6138 32.775 23.6813 32.7937 23.7525 32.7937C23.8313 32.7937 23.9025 32.7713 23.9663 32.7338C23.9888 32.88 24.0675 33.0188 24.2025 33.0863C24.2625 33.1163 24.3263 33.1313 24.3938 33.1313C24.4538 33.1313 24.51 33.1163 24.5588 33.09C24.5888 33.2325 24.6713 33.36 24.8025 33.4237C24.8625 33.45 24.9225 33.465 24.99 33.465C25.1663 33.465 25.3275 33.3563 25.3988 33.1875L25.4663 33.03C25.5788 32.7938 25.4775 32.5088 25.2525 32.4Z",
    fill: "#FFCA28"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M68.264 32.7883C68.204 32.7621 68.144 32.7471 68.0765 32.7471C68.0615 32.7471 68.0503 32.7508 68.0353 32.7546L68.054 32.7171C68.159 32.4846 68.069 32.2071 67.8478 32.0946C67.7878 32.0646 67.724 32.0496 67.6565 32.0496C67.6303 32.0496 67.604 32.0571 67.5778 32.0608C67.6715 31.8358 67.589 31.5696 67.379 31.4571C67.3153 31.4233 67.2478 31.4046 67.1765 31.4046C67.079 31.4046 66.9853 31.4421 66.9103 31.5021C66.884 31.3633 66.8015 31.2321 66.6628 31.1608C66.599 31.1271 66.5315 31.1121 66.464 31.1121C66.2915 31.1121 66.1378 31.2133 66.0628 31.3746L65.7178 32.1096C65.609 32.3421 65.699 32.6308 65.9353 32.7508C65.999 32.7846 66.0665 32.7996 66.1378 32.7996C66.209 32.7996 66.2728 32.7771 66.3328 32.7471C66.3365 32.7846 66.3328 32.8221 66.344 32.8558C66.3815 32.9758 66.4565 33.0733 66.5615 33.1296C66.6253 33.1633 66.6928 33.1821 66.764 33.1821C66.8428 33.1821 66.914 33.1596 66.9778 33.1221C67.0003 33.2683 67.079 33.4071 67.214 33.4746C67.274 33.5046 67.3378 33.5196 67.4053 33.5196C67.4653 33.5196 67.5215 33.5046 67.5703 33.4783C67.6003 33.6208 67.6828 33.7483 67.814 33.8121C67.874 33.8383 67.934 33.8533 68.0015 33.8533C68.1778 33.8533 68.339 33.7446 68.4103 33.5758L68.4778 33.4183C68.5903 33.1821 68.489 32.8971 68.264 32.7883Z",
    fill: "#FFCA28"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M25.335 32.37C25.5375 31.7025 24.7875 31.5413 24.7875 31.5413C24.8925 31.1625 24.2925 30.7275 23.9213 30.945C23.3663 30.39 22.9763 30.8963 22.9238 31.2488C22.9238 31.2488 23.2013 30.825 23.49 30.96C23.685 31.05 23.6813 31.2375 23.6213 31.4175C23.5275 31.6987 23.4488 31.9838 23.4488 31.9838C23.4488 31.9838 23.6588 31.6275 23.8388 31.3988C23.8988 31.32 24.09 31.1625 24.2925 31.275C24.495 31.3838 24.4988 31.635 24.4688 31.725C24.3713 32.0325 24.12 32.445 24.12 32.445C24.12 32.445 24.3075 32.2537 24.465 32.0737C24.5888 31.9312 24.6938 31.8413 24.8813 31.9275C25.0838 32.0213 25.0725 32.25 25.0125 32.3662C24.8888 32.6137 24.7275 32.91 24.7275 32.91C24.7275 32.91 25.02 32.4637 25.3238 32.715C25.515 32.8762 25.3463 33.27 25.3688 33.2475C25.9088 32.7 25.335 32.37 25.335 32.37Z",
    fill: "#EDA600"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3465 32.7585C68.549 32.091 67.799 31.9298 67.799 31.9298C67.904 31.551 67.304 31.116 66.9328 31.3335C66.3778 30.7785 65.9878 31.2848 65.9353 31.6373C65.9353 31.6373 66.2128 31.2135 66.5015 31.3485C66.6965 31.4385 66.6928 31.626 66.6328 31.806C66.539 32.0873 66.4603 32.3723 66.4603 32.3723C66.4603 32.3723 66.6703 32.016 66.8503 31.7873C66.9103 31.7085 67.1015 31.551 67.304 31.6635C67.5065 31.7723 67.5103 32.0235 67.4803 32.1135C67.3828 32.421 67.1315 32.8335 67.1315 32.8335C67.1315 32.8335 67.319 32.6423 67.4765 32.4623C67.6003 32.3198 67.7053 32.2298 67.8928 32.316C68.0953 32.4098 68.084 32.6385 68.024 32.7548C67.9003 33.0023 67.739 33.2985 67.739 33.2985C67.739 33.2985 68.0315 32.8523 68.3353 33.1035C68.5265 33.2648 68.3578 33.6585 68.3803 33.636C68.9203 33.0885 68.3465 32.7585 68.3465 32.7585Z",
    fill: "#EDA600"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_15421",
    x1: 28.8657,
    y1: 20.7734,
    x2: 23.9913,
    y2: 29.9125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_15421",
    x1: 71.8772,
    y1: 21.1619,
    x2: 67.0028,
    y2: 30.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_15421",
    x1: 25.0744,
    y1: 28.9039,
    x2: 26.3588,
    y2: 26.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_15421",
    x1: 68.0859,
    y1: 29.2923,
    x2: 69.3703,
    y2: 27.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA28",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_15421",
    x1: 38.898,
    y1: 20.0595,
    x2: 46.1951,
    y2: 32.4724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_15421",
    x1: 81.9095,
    y1: 20.4479,
    x2: 89.2066,
    y2: 32.8608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_15421",
    x1: 34.3298,
    y1: 16.4303,
    x2: 34.3298,
    y2: 29.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#F78C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#F47F12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_15421",
    x1: 77.3413,
    y1: 16.8187,
    x2: 77.3413,
    y2: 29.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#F78C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#F47F12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6889 14.2511) scale(3.79688 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.7004 14.6395) scale(3.79688 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4297 13.6856) rotate(154.924) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.4412 14.0741) rotate(154.924) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5212 10.5129) rotate(-94.2783) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.5327 10.9015) rotate(-94.2783) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1316 10.5128) rotate(-85.7217) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.1431 10.9011) rotate(-85.7217) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9642 14.2511) rotate(180) scale(3.79688 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.9758 14.6395) rotate(180) scale(3.79688 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2235 13.6856) rotate(25.0761) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2351 14.0741) rotate(25.0761) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2458 7.91207) rotate(72.0851) scale(5.77679 4.28624)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.2573 8.30043) rotate(72.0851) scale(5.77679 4.28624)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6144 1.61426) rotate(28.2026) scale(1.51466 1.79594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.626 2.0026) rotate(28.2026) scale(1.51466 1.79594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9997 4.36421) rotate(-157.19) scale(4.73721 2.66233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0112 4.75257) rotate(-157.19) scale(4.73721 2.66233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0057 2.99539) scale(1.39013 1.70054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.0172 3.38382) scale(1.39013 1.70054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8133 5.4503) rotate(-164.942) scale(2.60747 2.44012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.8248 5.83869) rotate(-164.942) scale(2.60747 2.44012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1971 7.96719) rotate(7.83354) scale(2.73759 3.84676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.2086 8.35554) rotate(7.83354) scale(2.73759 3.84676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3_15421",
    x1: 9.1365,
    y1: 20.0595,
    x2: 1.83937,
    y2: 32.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3_15421",
    x1: 52.148,
    y1: 20.4479,
    x2: 44.8509,
    y2: 32.8612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3_15421",
    x1: 19.1612,
    y1: 19.8295,
    x2: 25.3942,
    y2: 32.9255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3_15421",
    x1: 62.1727,
    y1: 20.218,
    x2: 68.4057,
    y2: 33.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FFCA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3_15421",
    x1: 5.30325,
    y1: 22.8401,
    x2: 22.0463,
    y2: 22.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#42BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#20B3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#03A9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3_15421",
    x1: 48.3148,
    y1: 23.2286,
    x2: 65.0578,
    y2: 23.2286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#42BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#20B3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#03A9F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0361 14.2511) scale(3.79687 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.0476 14.6395) scale(3.79687 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7779 13.685) rotate(154.924) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7894 14.0734) rotate(154.924) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.869 10.513) rotate(-94.2783) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.8805 10.9015) rotate(-94.2783) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4794 10.5123) rotate(-85.7217) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4909 10.9006) rotate(-85.7217) scale(4.92818 4.10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3115 14.2511) rotate(180) scale(3.79688 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.323 14.6395) rotate(180) scale(3.79688 1.86503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.57171 13.6859) rotate(25.0761) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5832 14.0743) rotate(25.0761) scale(1.12194 0.832322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.593 7.91212) rotate(72.0851) scale(5.77679 4.28624)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6045 8.30048) rotate(72.0851) scale(5.77679 4.28624)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9614 1.6139) rotate(28.2026) scale(1.51466 1.79594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9729 2.00224) rotate(28.2026) scale(1.51466 1.79594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6D4C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3476 4.36284) rotate(-157.19) scale(4.73721 2.66233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3591 4.7512) rotate(-157.19) scale(4.73721 2.66233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.353 2.99539) scale(1.39012 1.70054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3645 3.38382) scale(1.39012 1.70054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1616 5.44964) rotate(-164.942) scale(2.60747 2.44012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1731 5.83818) rotate(-164.942) scale(2.60747 2.44012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.54365 7.96692) rotate(7.83355) scale(2.73759 3.84676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_3_15421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5552 8.35527) rotate(7.83355) scale(2.73759 3.84676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6D4C41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4C41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoPeopleHoldingHands);
export default __webpack_public_path__ + "static/media/noto_people-holding-hands.22e395cc3865d26728418e4cb7b7762b.svg";
export { ForwardRef as ReactComponent };